import {useCurrentUser} from '@/composables/use-current-user.js'
import {useCurrentOrganization} from '@/composables/use-current-organization.js'
import {ref, computed} from 'vue'

/**
 * Timezone composable
 */
export function useTimezone() {

  //Get current user and organization
  const {user} = useCurrentUser()
  const {organization} = useCurrentOrganization()

  //Timezone to use throughout the app
  const defaultTimezone = ref('America/New_York')
  const timezone = computed(() => {
    return user.value?.timezone || organization.value?.timezone || defaultTimezone.value
  })

  //Expose interface
  return {
    defaultTimezone,
    timezone,
  }
}
